export const otherUsersPermission = {
  clientFilter: false,
};
